import React from 'react'

import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Styles from "../../scss/orderHistory.module.scss";

interface ITableAreaProps {
  filterItems: Record<string, boolean> ;
  onFiltersChange:(event: React.ChangeEvent<HTMLInputElement>)=>void;
  areaName:string;
  tableAreas:Record<string, boolean>;
}
export default function TableAreas({ filterItems ,tableAreas, onFiltersChange , areaName}:ITableAreaProps) {
  return (
    <FormControlLabel
      control={<Checkbox
        checked={filterItems.TABLE_DELIVERY && tableAreas[areaName]}
        onChange={onFiltersChange}
        name={areaName}
        color="primary"
        disabled={!filterItems.TABLE_DELIVERY}
      />}
      label={areaName}
      className={Styles.filtersCheckboxes}
    />
  )
}
